
import { Container } from 'react-bootstrap';

const Banner = () => {

    return (
        <Container  id='banner' className="bg-wwa mt-auto">
            <h1 className="col-white ps-5 ms-5 pt-5 mt-5">
                A BETTER WAY<br></br>TO TRAIN...
            </h1>
        </Container>
    );
}

export default Banner;
